const initState =
{
  center          : ['-0.147212', '-78.475252'],
  layers          : true,
  location        : null,
  zoom            : 12,

  selected        : null,
  last            : null,
}

const mapReducer = (state = initState, action) =>
{
  switch (action.type)
  {
    case 'SET_CENTER':
      return {
        ...state,
        center: action.center
      };

    case 'SET_LAST':
      return {
        ...state,
        last: action.last
      };

    case 'SET_LAYERS':
      return {
        ...state,
        layers: action.layers
      };
   
    case 'SET_LOCATION':
      return {
        ...state,
        location: action.location
      };    

    case 'SET_SELECTED':
      return {
        ...state,
        selected: action.selected
      }; 

    case 'SET_ZOOM':
      return {
        ...state,
        zoom: action.zoom
      };       

    default:
      return state; 
  }
}

export default mapReducer;